module.exports = __webpack_public_path__ + "static/media/sumenh4.22d9dd99.png";